/** What the media-replacement modal was opened for. */
type ReplaceMediaTarget = {
  isLogo?: boolean;
  isVideo?: boolean;
  isHeadshot?: boolean;
};

/**
 * Title for the media-replacement modal: "Replace Logo", "Replace Video",
 * "Replace Headshot", "Replace Image".
 *
 * One shared picker serves all of them, so it used to carry a single generic
 * title — "Swap or Search for a New Image" — which named the wrong subject
 * (a logo, a video) and did not match the action-first titles the rest of the
 * family uses (Replace Captions, Replace Intro Card).
 */
export function getReplaceMediaTitle(
  { isLogo, isVideo, isHeadshot }: ReplaceMediaTarget,
  isAdding = false,
): string {
  const action = isAdding ? 'Add' : 'Replace';
  if (isLogo) return `${action} Logo`;
  if (isVideo) return `${action} Video`;
  if (isHeadshot) return `${action} Headshot`;
  return `${action} Image`;
}
